import { autoinject, computedFrom } from 'aurelia-framework';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { WidgetBase } from 'support/base_classes/widget-base';
import { SystemUserContactWrapper } from 'model/support-types';
import { LookupsService } from 'services/lookups-service';
import { ValidationRules } from 'aurelia-validation';

@autoinject
export class AdminUserContactSelectorWidget extends WidgetBase<SystemUserContactWrapper, WidgetController> {
  constructor(private lookups: LookupsService) {
    super();
  }

  changed() {
    ValidationRules
      .ensureObject<SystemUserContactWrapper>().required()
      .ensure(model => model.user).displayName('Employee').required()
      .ensure(model => model.countriesContactEmail).displayName('Countries Email').email().withMessage('Countries Email must have valid format.')
      .on(this.model);
  }

  @watch((x: AdminUserContactSelectorWidget) => x.model.user)
  private userChanged() {
    this.model.countriesContactEmail = this.model.user?.countriesContactEmail;
  }

  @computedFrom('model.user')
  get userGroupLabel() {
    return this.model.user != null ?
      [`role: ${this.model.user.jobTitle ?? ''}`, `bp email: ${this.model.user.mail ?? ''}`, this.controller.disabled ? `countries email: ${this.model.countriesContactEmail ?? ''}` : null, `phone: ${this.model.user.phone ?? ''}`].filter(l => l != null && l !== '')
      : 'Employee'
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();
}
